import pathfinder from '@fiverr-private/pathfinder';
import { getDefaultLocaleValue } from '../../../../shared/utils';
import { PATHS, PATHFINDER } from '../../constants';


export const getCategoryPath = ({ id }, source) => {
    if (!id) {
        return PATHS.ROOT;
    }

    if (isNaN(parseInt(id, 10))) {
        return PATHS.ROOT;
    }

    const categorySlug = getDefaultLocaleValue(`categories.category_${id}.cached_slug`);
    const params = { id: categorySlug };
    const options = { query: { source } };

    return categorySlug ? pathfinder(PATHFINDER.CATEGORY, params, options) : '';
};
